// Centralized API Base URL configuration
const getApiBaseUrl = () => {
  // Support both REACT_APP_API_URL and REACT_APP_API_BASE_URL
  let url = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

  // Normalize string: trim whitespace
  url = url.trim();

  // Remove trailing slashes
  url = url.replace(/\/+$/, '');

  // If the user appended /api to the base URL in .env (e.g. http://localhost:5000/api), strip it
  // so base URL is standard host without trailing /api
  if (url.endsWith('/api')) {
    url = url.substring(0, url.length - 4);
  }

  return url;
};

export const API_BASE_URL = getApiBaseUrl();

export default API_BASE_URL;
